export default "__VITE_ASSET__DCcWhl_B__"